import { Box, SxProps, Theme } from '@mui/material';
import Image, { ImageProps } from 'next/image';
import { FC, useEffect, useState } from 'react';

export const HBNextImage: FC<ImageProps & { imageNotFound?: string; sx?: SxProps<Theme> }> = (
  props,
) => {
  const {
    width = 50,
    height = 50,
    placeholder = 'blur',
    src: srcProps,
    imageNotFound,
    quality = 75,
    sx,
    ...rest
  } = props;
  const [src, setSrc] = useState(srcProps);
  const cdnUrl = process.env['NEXT_PUBLIC_CDN'];
  const notFoundUrl = cdnUrl + '/cdn/images/not-found.svg';

  useEffect(() => {
    setSrc(srcProps);
  }, [srcProps]);

  return (
    <Box sx={sx}>
      <Image
        width={width && height ? width : undefined}
        height={width && height ? height : undefined}
        loader={({ src, width: defaultWidth }) => {
          const width = props.width || defaultWidth ? `&w=${props.width || defaultWidth}` : '';
          const height = props.height ? `&h=${props.height}` : '';
          return `${src}?q=${quality}${width}${height}&wpq=1`;
        }}
        blurDataURL={'/assets/svg/skeleton-image.svg'}
        src={src}
        onError={() => setSrc(imageNotFound || notFoundUrl)}
        {...{
          placeholder,
          quality,
          ...rest,
        }}
      />
    </Box>
  );
};
